import { Box } from "@chakra-ui/react";
import Router from "@root/routes";
import "./App.css";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import reduxStore from "@store/index";
import { ChakraWrapper } from "@components/index";
import { I18nextProvider } from "react-i18next";
import i18n from "@root/i18n";
import "./rc-pagination.css";
import { BUILD_ENV } from "./constants";
import DisableDevtool from "disable-devtool";
import { CourseManagementProvider } from "./context/course-management-context";
import { NoticeProvider } from "./context/notice-context";
import { CategoryProvider } from "./context/admin-categories";
import { JournalistProvider } from "./context/journalist-context";
import { NoticeTypeProvider } from "./context/notice-type-context";
import { useEffect } from "react";
import { AuthService } from "./services";
import { MyLearningProvider } from "./context/my-learning-context";
import { CertificateProvider } from "./context/certificate-context";
import React from "react";
import { SessionRoleRestorer } from "@components/session-role-restorer";
import { TourGuideProvider } from "./context/tour-guide-context";
import { OrganizationBrandingProvider } from "./context/organization-branding-context";

export const { store, persistor } = reduxStore();

function App() {
  const setCookies = async () => {
    try {
      const authService = new AuthService();
      await authService.setCookies();
    } catch (e) {
      console.warn("Failed to set cookies:", e);
    }
  };

  useEffect(() => {
    setCookies();
  }, []);

  if (process.env.REACT_APP_ENV === BUILD_ENV.PRODUCTION) {
    DisableDevtool();
  }

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <SessionRoleRestorer>
          <I18nextProvider i18n={i18n}>
            <Box className="App">
              <div id="scrollableDiv" className="hide-scrollbar">
                <OrganizationBrandingProvider>
                  <TourGuideProvider>
                    <CategoryProvider>
                      <CourseManagementProvider>
                        <NoticeProvider>
                          <NoticeTypeProvider>
                            <JournalistProvider>
                              <CertificateProvider>
                                <MyLearningProvider>
                                  <ChakraWrapper>
                                    <Router />
                                  </ChakraWrapper>
                                </MyLearningProvider>
                              </CertificateProvider>
                            </JournalistProvider>
                          </NoticeTypeProvider>
                        </NoticeProvider>
                      </CourseManagementProvider>
                    </CategoryProvider>
                  </TourGuideProvider>
                </OrganizationBrandingProvider>
              </div>
            </Box>
          </I18nextProvider>
        </SessionRoleRestorer>
      </PersistGate>
    </Provider>
  );
}

export default App;
